export const IGNORE_VALIDATION_ERRORS = 'jaga-ignore-validation-errors';
